var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"author"},[_vm._v("\n  负责人：晁凯\n  "),_c('br'),_vm._v("邮箱：chaokai@tom.com\n  "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-button',{staticClass:"btn",on:{"click":_vm.back}},[_vm._v("返回首页")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa8b3ba6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/sales_management/author.vue
// module id = null
// module chunks = 